import styled from 'styled-components';

import { Box } from '../../../common/ui/Box';
import { theme } from '../../../common/ui/theme';

export const ApproverListWrapper = styled(Box)`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.space[8]};
`;
